import React, { Component } from 'react'
import '../App.css';
import './styles/LeftCircle.css';
import { ReactComponent as CircleDashed } from '../assets/Circle Dashed.svg'
import { ReactComponent as CircleWhole } from '../assets/Circle Whole.svg'

// import CircleDashed from './assets/Circle Dashed.svg';
// import CircleWhole from './assets/Circle Whole.svg';

const HIDE_LEFT = 10;
const HIDE_UP = 12;

export default class LeftCircle extends Component {

  render() {
    let sizeClass = '';
    let wholeCircleClass = '';
    let hiddenClass = '';

    if (this.props.isFocus) {
      sizeClass = 'square-lg';
      wholeCircleClass = 'moved';
    } else {
      sizeClass = 'square-sml';
    }

    if (this.props.hideDirection == HIDE_LEFT) {
      hiddenClass = 'hidden-left';
    } else if (this.props.hideDirection == HIDE_UP) {
      hiddenClass = 'hidden-up';
    }

    return (
      <div className={`left-square ${sizeClass} ${hiddenClass}`}>
        <div className='circle-container'>
          {/* <img src={CircleDashed} className="left-dashed-circle" />
          <img src={CircleWhole} className={`left-whole-circle ${wholeCircleClass}`} /> */}
          <CircleDashed className="left-dashed-circle" />
          <CircleWhole className={`left-whole-circle ${wholeCircleClass}`} />
				</div>
      </div>
    )
  }
}
